import React, { useState, useEffect, useRef } from "react";
import * as th from "./tree_app.js"
import LoginPage from "./pages/login/LoginPage"
import { useDispatch, useSelector } from "react-redux";
import LandingPage from "./pages/login/LandingPage";
import RegisterPage from "./pages/login/RegisterPage";
import AppHeader from "./pages/component/AppHeader";
import AppMenu from "./pages/component/AppMenu";
import AppLoginPage from "./pages/component/AppLoginPage";
import AppRegisterPage from "./pages/component/AppRegisterPage";
import HRMPage from "./pages/admin/hrm/HRMPage"
import VIEPage from "./pages/admin/vie/VIEPage"
import { Box, Button, Grid, Paper, TextField } from "@mui/material";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import api from "./API";
import { setUserInfo } from "./redux/slice/user";
import EVALPage from "./pages/admin/eval/EVALPage";

interface pageProps {
  adminRole: boolean
}

const AdminApp = (props:pageProps) => {

  // const auth = useSelector((state:any)=> state)

  // console.log('auth',auth)

  const dispatch = useDispatch();

  const loc = useLocation()

  const nav = useNavigate()

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const getAuth = async () => {
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)) })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  useEffect(() => {
    getAuth()
    if(loc.pathname == '/admin')
      nav('/admin')
  },[]);

  return (
    <Box>
      <Box sx={{ backgroundColor: "#fff", height: "100%", maxWidth: "100%" }}>
        <AppHeader />

        {/* 헤더아래 가로 메뉴 */}
        <AppMenu adminRole={props.adminRole} />

        <Routes>
          <Route path="vie/*" element={<VIEPage />} />
          <Route path="hrm/*" element={<HRMPage />} />
          <Route path="eval/*" element={(<EVALPage />)} />

          {/* 기본값 VIE */}
          <Route path="" element={(<EVALPage />)} />
        </Routes>
        {/* <LandingPage /> */}
      </Box>
    </Box>
    );
}

export default AdminApp;
